<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/opportunities-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Cerrar esta oportunidad</h4></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <div class="d-grid prospect-form mt-4" style="grid-template-columns: auto 1fr; justify-content: center; align-items: baseline;">
            <div><label class="login-label"><span class="color-org">*</span> Etapa:</label></div>
            <div>
                <select class="crm-input" [(ngModel)]="statusSlc" (change)="readStatus()">
                    @for(item of status; track item.id_estado) {
                        <option [value]="item.id_estado" [selected]="item.nombre === 'Cerrada Ganada'">{{ item.nombre }}</option>
                    }
                </select>
            </div>
            </div>
            <hr class="mt-4">
            <div class="d-flex flex-row justify-center gap-20 mt-4">
                <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                <button class="btn btn-primary text-center" (click)="closeOpportunity()">Aceptar</button>
            </div>
        </div>
    </div>
</div>